import { call, select, takeEvery } from 'redux-saga/effects';

import { TRACK_IN_HEAP } from '../constants/actionTypes';
import { track } from '../lib/heapHelpers';
import { buildServerSelector } from '../reducers/selectors';

function* heapWatcher() {
  yield takeEvery(TRACK_IN_HEAP, heapWorker);
}

function* heapWorker(action) {
  const builder = yield select(buildServerSelector);
  const { payload } = action;
  const { heapEventType, errorCount, errorDetailsIn } = payload;
  const { id: applicationId, customerGuid } = builder;
  const errorInformation = JSON.stringify(errorDetailsIn);
  yield call(track, heapEventType, {
    'Application GUID': applicationId,
    'Customer GUID': customerGuid,
    'Application Error Count': errorCount,
    'Application Error Information': errorInformation,
  });
}

export { heapWorker };
export default heapWatcher;
